import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NearByServiceManagementComponent } from './near-by-service-management.component';

const routes: Routes = [
  {
    path: '', component: NearByServiceManagementComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NearByServiceManagementRoutingModule { }
